import { Component, Input, SimpleChanges } from '@angular/core';
import { SOURCE } from '@shared/enum/source.enum';
import { SOCTRIP_HOTLINE } from '@shared/constant';

@Component({
  selector: 'app-baggage-details',
  templateUrl: './baggage-details.component.html',
  styleUrls: ['./baggage-details.component.scss']
})
export class BaggageDetailsComponent {
  @Input() flightInfo: any;
  @Input() operatingCode: string;
  SOURCE = SOURCE;
  SOCTRIP_HOTLINE = SOCTRIP_HOTLINE;
  
  isShowBaggagePopup = false;
  tooltipStyle: { [key: string]: string } = {};
  isDirtyHover: boolean = false;
  closeTimer: any;

  showBaggageTooltipInfo(event?: any) {
    this.calculateTooltipPosition(event);
    this.isShowBaggagePopup = true;
    this.isDirtyHover = true;
  }

  onTriggerEnter(event: MouseEvent, op: any) {
    clearTimeout(this.closeTimer);
    op.show(event);
  }

  onTriggerLeave(op: any) {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => op.hide(), 200);
  }
  
  onPanelEnter() {
    clearTimeout(this.closeTimer);
  }
  
  onPanelLeave(op: any) {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => op.hide(), 150);
  }

  keepBaggageTooltipInfo() {
    this.isShowBaggagePopup = true;
  }

  hideBaggageTooltipInfo() {
    this.isShowBaggagePopup = false;
  }

  calculateTooltipPosition(event: any) {
    const elementRect = event.target?.getBoundingClientRect();
    const elementTop = elementRect.top;
    const elementHeight = elementRect.height;
    const windowHeight = window.innerHeight;
    const spaceAtBottom = windowHeight - (elementTop + elementHeight);
    const spaceAtTop = elementTop;

    if (spaceAtBottom < spaceAtTop) {
      this.tooltipStyle = {
        bottom: '24px',
      };
    } else {
      this.tooltipStyle = {
        top: '24px',
      };
    }
  }
}
